import { List } from "@mui/material"
import React, { useContext } from "react"
import { UserContext } from "src/providers"
import NavbarEntry from "./NavbarEntry"
import { useResponsive } from "src/utils/useResponsive"

export const HomeEntry = ({ open, onNavigate }: { open: boolean; onNavigate?: () => void }) => {
  const { companyPortalProperties } = useContext(UserContext)
  const { isMobile } = useResponsive()
  const logoSvgName = companyPortalProperties.companyId
    ? `${companyPortalProperties.companyId}.svg`
    : "exfluency_logo.svg"
  const logoSrc = `https://${
    process.env.REACT_APP_S3_BUCKET || "dev-exfluency-portal"
  }.s3.eu-central-1.amazonaws.com/logo/${logoSvgName}`

  const showLogo = open || isMobile
  const iconPath = showLogo ? logoSrc : "/exfluency/portal-icon_home.svg"

  return (
    <List>
      <NavbarEntry
        open={open}
        key="home"
        iconPath={iconPath}
        label={"Home"}
        hideLabel
        path="/"
        data-testid={`menu-home-button`}
        onNavigate={onNavigate}
      />
    </List>
  )
}
